const schema9142B = {
  tableScreen: {
    title: "H-2B Registration Number Lookup",
    headerInNetwork:
      "Locate a registration number which has been issued for one of your account/network’s 9142Bs that matches the need of this case.",
    headerOutNetwork:
      "Locate a registration number issued to another user account/network that matches the need of this case ",
    searchTermText:
      "(Use the search below to refine by Registration Number, Employer Name, and Number of Workers.)",
    searchTermTextOutOfNetwork:
      "(The full Registration Number must be entered, for example H2B-REG-XXXXXXXX)",
    queryCriteriaInNetwork: `
    The H-2B Registration Number Lookup uses the following criteria to find Registration Numbers which are valid for linking in your account/network:
    <br/>
    <ul>
    <li>The Registration Number status must be Active,</li>
    <li>The Registration Number must match following values in the current 9142B case,</li>
    <ul><li>Type of Need (field B.7),</li>
    <li>Employer FEIN (field C.12),</li>
    <li>Primary Worksite MSA (field F.b.7),</li></ul>
    <li>The current case must not have a total number of workers that is more than 20% of the total workers in a registration number, if the number of workers is great than or equal to 10 workers (e.g., registration is for 100 workers, they can request up to 120),</li>
    <li>The current case must not have a total number of workers that is more than 50% of the total workers in a registration number, if the number of workers is less than 10 workers (e.g., registration is for 8 workers, they can request up to 12 workers),</li>
    <li>The current case must not have changed by more than a total of 30 calendar days for the entire period of need in a registration number,</li>
    </ul>`,
    queryCriteriaOutNetwork: `
    The H-2B Registration Number Lookup uses the following criteria to confirm if a entered Registration Number which is not in your account/network is valid for linking:
    <br/>
    <ul>
    <li>The Registration Number status must be Active,</li>
    <li>The Registration Number must match following values in the current 9142B case,</li>
    <ul><li>Type of Need (field B.7),</li>
    <li>Employer FEIN (field C.12),</li>
    <li>Primary Worksite MSA (field F.b.7),</li></ul>
    <li>The current case must not have a total number of workers that is more than 20% of the total workers in a registration number, if the number of workers is great than or equal to 10 workers (e.g., registration is for 100 workers, they can request up to 120),</li>
    <li>The current case must not have a total number of workers that is more than 50% of the total workers in a registration number, if the number of workers is less than 10 workers (e.g., registration is for 8 workers, they can request up to 12 workers),</li>
    <li>The current case must not have changed by more than a total of 30 calendar days for the entire period of need in a registration number,</li>
    </ul>`,
  },
  acknowledgmentScreen: {
    title: "",
    body: "Employer FEIN (C.12), Primary Worksite MSA (F.b.7) and Type of Need (B.7) cannot be modified while this registration number is linked to this case. Unlink this registration number if you need to modify any of these values.",
  },
};

export default schema9142B;
